/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clinical-records': {
    width: 30,
    height: 32,
    viewBox: '0 0 30 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M2 4.333C2 3.071 3.06 2 4.429 2H15v7.333a1 1 0 001 1h8V12a1 1 0 102 0V9.333a1 1 0 00-.303-.717L17.126.283A1 1 0 0016.429 0h-12C2.009 0 0 1.914 0 4.333v23.334C0 30.087 2.01 32 4.429 32H21.57C23.991 32 26 30.086 26 27.667V25a1 1 0 10-2 0v2.667C24 28.929 22.94 30 21.571 30H4.43C3.06 30 2 28.929 2 27.667V4.333zM17 2.95v5.383h5.537L17 2.95zm7.708 10.958a3.1 3.1 0 114.384 4.384l-8.415 8.415a1 1 0 01-.707.293H17a1 1 0 01-1-1v-2.97a1 1 0 01.293-.707l8.415-8.415zM18 25h1.556l5.125-5.125-1.556-1.556L18 23.444V25zm6.54-8.095l1.555 1.556 1.583-1.583a1.1 1.1 0 00-1.556-1.556l-1.583 1.583z" _fill="#1F222C"/>'
  }
})
